import styled from 'styled-components';

export const Wrapper = styled.div`
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 80px);
    gap: 20px;
`;
